export const GET_LIST_REPORTS = "GET_LIST_REPORTS";
export const GET_LOADING_MONETIZATIONS = "GET_LOADING_MONETIZATIONS";

// Iniciar monetización
export const GET_START_LIST_MONETIZATION = "GET_START_LIST_MONETIZATION";
export const GET_EMAIL_SEND_MONETIZATION = "GET_EMAIL_SEND_MONETIZATION";

// Confirmar monetización
export const GET_LIST_MONETIZATIONS = "GET_LIST_MONETIZATIONS";
export const GET_LIST_CONFIRM_MONETIZATION = "GET_LIST_CONFIRM_MONETIZATION";
